import { Box, Button, Container, Dialog, DialogContent, DialogTitle, IconButton, Typography } from "@material-ui/core";
import { FC, Fragment, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { closeModal } from "store/modules/ModalActions";
import '../index.scss'
import { Row } from "components/Row";
import CloseIconModal from "assets/icons/CloseIconModal";
import useProgramas from "../../../hooks/useProgramas";
import { getProgramaInfo, postPrograma } from "store/modules/EscolasActions";
import SnackbarUtils from '../../../../../../../../utils/SnackbarUtils';
import { RootState } from "store";
interface ModalAvisoProps {
    title: string;
    cancelCallback: () => void;
    confirmCallback?: () => void;
    confirmLabel?: string;
    cancelLabel?: string;
    content?: React.ReactNode;
    confirmThemeButton?: string;
    cancelThemeButton?: string;
    tipoPrograma: string,
    ano: string;
    idEscola: string;
    modalKey: string;
}

const ModalAviso: FC<ModalAvisoProps> = ({
    modalKey,
    title,
    cancelCallback,
    confirmCallback,
    confirmLabel,
    content,
    cancelLabel,
    confirmThemeButton,
    cancelThemeButton,
    tipoPrograma,
    idEscola,
    ano
}) => {
    const { getNomePrograma } = useProgramas();
    const nomeEscola = useSelector((state: RootState) => state.escolas.escolaEditing.nomeFantasia)
    const dispatch = useDispatch();

    const toClose = useCallback(() => {
        dispatch(closeModal(modalKey));
    }, [dispatch, modalKey]);

    const toCancel = useCallback(() => {
        if (typeof cancelCallback === 'function') {
            cancelCallback();
        }
        toClose();
    }, [cancelCallback, toClose]);

    return (
        <Dialog
            className='GenericModal'
            open={true}
            onClose={toCancel}
            closeAfterTransition
            disableEscapeKeyDown
            fullScreen
        >
            <Box>
                <DialogTitle className='GenericModal_dialogTitle'>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography className='GenericModal_titleText'>
                            {title}
                        </Typography>
                        <IconButton
                            onClick={(e) => {
                                e.stopPropagation();
                                toCancel();
                            }}
                            size="small"
                        >
                            <CloseIconModal style={{ width: 'auto', height: '22px' }} />
                        </IconButton>
                    </Box>
                </DialogTitle>

                <DialogContent>
                    {content || (
                        <Fragment>
                            Você confirma que o programa <strong>{getNomePrograma(tipoPrograma)}</strong> foi implementado
                            no ano de <strong>{ano}</strong> na escola <strong>{nomeEscola}</strong>? Essa ação é irreversível!
                        </Fragment>
                    )}
                </DialogContent>
                <Container className='GenericModal_dialogActions'>
                    <Row className='GenericModal_row'>
                        <Box
                            className='GenericModal_box-buttons'
                            onClick={(e) => e.stopPropagation()}
                        >
                            <Button
                                className={`GenericModal_action-button ${cancelThemeButton || ''}`}
                                variant='contained'
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    cancelCallback?.();
                                    dispatch(closeModal(modalKey));
                                }}
                            >
                                {cancelLabel || 'Cancelar'}
                            </Button>
                            <Button
                                className={`GenericModal_action-button ${confirmThemeButton || ''}`}
                                variant="contained"
                                type="button"
                                onClick={async () => {

                                    if (typeof confirmCallback === 'function') {
                                        confirmCallback();
                                        dispatch(closeModal(modalKey));
                                        return;
                                    }
                                    try {
                                        await new Promise<void>((resolve, reject) => {
                                            postPrograma(
                                                Number(idEscola),
                                                Number(tipoPrograma),
                                                ano,
                                                resolve,
                                                reject
                                            )();
                                        });
                                        SnackbarUtils.enqueueSnackbar({
                                            message: 'Programa cadastrado com sucesso',
                                            options: { variant: 'success' },
                                        });
                                        dispatch(getProgramaInfo(idEscola));
                                        dispatch(closeModal('modal-programa'));
                                        dispatch(closeModal(modalKey));
                                    } catch (errorMessage) {
                                        SnackbarUtils.enqueueSnackbar({
                                            message: String(errorMessage),
                                            options: { variant: 'error' },
                                        });
                                    }
                                }}
                            >
                                {confirmLabel || 'Confirmar'}
                            </Button>
                        </Box>
                    </Row>
                </Container>
            </Box>
        </Dialog >
    );
};

export default ModalAviso;
